import DeletePathModal from './DeletePathModal'
export default DeletePathModal
